export const REGIONS = {
  US: 'US',
  EU: 'EU',
};
